import { CLEAR_LOYALTY_ENROLMENT } from 'actions/actionConstants'
import type { AppAction } from 'actions/types/ActionTypes'

function clearLoyaltyEnrolment(): AppAction {
  return {
    type: CLEAR_LOYALTY_ENROLMENT,
  }
}

export default clearLoyaltyEnrolment
